"use client";

import React, { useEffect, useRef, useState } from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const galleryImagesCol1 = [{
  src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/bodyconcept_SchlankimLiegen1-scaled.jpg?v=mqjog5r16g",
  alt: "Präzisions-Hautbehandlung im Detail"
}, {
  src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/Bodyconcept_linda_empfang.jpg?v=jcfda5wdecf",
  alt: "Modernes und beruhigendes Ambiente der Beauty Lounge"
}];
const galleryImagesCol2 = [{
  src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/bodyconcept_BEWEI_lymphe-scaled.jpg?v=6eneh4zcde",
  alt: "Hochwertige Pflegeprodukte für Ihre Haut"
}, {
  src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/bodyconcept_BEWEI_face1-scaled.jpg?v=4ubkmi6ztkx",
  alt: "Ganzheitliches Wohlbefinden und Entspannung"
}];
export default function TheVectrPhilosophy() {
  const sectionRef = useRef<HTMLElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const scrolled = windowHeight - rect.top;
      const total = windowHeight + rect.height;
      const progress = Math.max(0, Math.min(1, scrolled / total));
      setScrollProgress(progress);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    window.addEventListener("resize", handleResize);
    handleScroll();
    handleResize();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const grainOverlay = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`;
  return <section data-section-id="223697" id="das-linda-prinzip" ref={sectionRef} className="bg-background text-foreground relative w-full overflow-hidden py-16 lg:py-20">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col gap-16 relative lg:flex-row lg:gap-24">
          
          <div className="lg:w-5/12 lg:sticky lg:top-24 lg:self-start flex flex-col justify-center z-10">
            <div className="mb-12">
              
            </div>
            
            <h2 className="font-default leading-[1.1] tracking-tight text-foreground uppercase !font-semibold !text-5xl">Lindas Weg zum Wohlgefühl.<span className="text-primary font-script normal-case !font-serif !not-italic !text-6xl" data-ast-id="f:/src/pages/Home/sections/TheVectrPhilosophy.tsx|sig:k74248" data-ast-start="3145" data-ast-end="3393" contenteditable="false" style={{}}></span></h2>
            
            <p className="mt-8 text-muted-foreground text-lg max-w-md font-default font-light leading-[1.8]">„Ankommen, loslassen und den Körper neu spüren. Mein ganzheitlicher Ansatz vereint sanfte Pflege mit modernster Technik für Ihr bestes Ich. Von entspanntem Körperforming bis hin zur gezielten Kräftigung der Beckenbodenmuskulatur für ein sicheres Gefühl in jeder Lebensphase: Wir schaffen die Balance zwischen ästhetischem Anspruch und körperlicher Gesundheit. Schenken Sie sich die Aufmerksamkeit, die Sie verdienen – für ein strahlendes Aussehen und ein starkes Körpergefühl."</p>

            <div className="mt-6">
              <p className="font-script text-4xl text-primary/80 !font-serif !italic">Eure Linda</p>
            </div>

            <div className="mt-12">
              <a href="#loesungen" className="inline-flex items-center justify-center font-medium transition-all duration-300 border border-primary text-primary hover:bg-primary hover:text-white px-10 h-14 rounded-lg text-lg">
                Mein Konzept entdecken
              </a>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-6 relative z-0 lg:w-7/12 md:gap-8">
            
            <div className="w-full lg:flex-1 flex flex-col gap-6 will-change-transform md:gap-8" style={{
            transform: isMobile ? 'none' : `translateY(${scrollProgress * -150}px)`,
            transition: 'transform 0.1s ease-out'
          }}>
              {galleryImagesCol1.map((img, i) => <div key={`col1-${i}`} data-index={i} className="relative w-full overflow-hidden bg-accent/20 group rounded-3xl shadow-sm hover:shadow-xl transition-shadow duration-700">
                  <AspectRatio ratio={3 / 4}>
                    <div className="absolute inset-0 z-10 opacity-10 mix-blend-overlay pointer-events-none" style={{
                  backgroundImage: grainOverlay
                }} />
                    <img src={img.src} alt={img.alt} className="object-cover w-full h-full brightness-105 group-hover:scale-110 transition-all duration-1000 ease-in-out" />
                  </AspectRatio>
                </div>)}
            </div>

            <div className="w-full flex flex-col gap-6 lg:flex-1 lg:mt-24 md:gap-8" style={{
            transform: isMobile ? 'none' : `translateY(${scrollProgress * -50}px)`,
            transition: 'transform 0.1s ease-out'
          }}>
              {galleryImagesCol2.map((img, i) => <div key={`col2-${i}`} data-index={i} className="relative w-full overflow-hidden bg-accent/20 group rounded-3xl shadow-sm hover:shadow-xl transition-shadow duration-700">
                  <AspectRatio ratio={isMobile ? 3 / 4 : 9 / 14}>
                    <div className="absolute inset-0 z-10 opacity-10 mix-blend-overlay pointer-events-none" style={{
                  backgroundImage: grainOverlay
                }} />
                    <img src={img.src} alt={img.alt} className="object-cover w-full h-full brightness-105 group-hover:scale-110 transition-all duration-1000 ease-in-out" />
                  </AspectRatio>
                </div>)}
            </div>

          </div>
        </div>
      </div>
    </section>;
}